/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import './Navbar.css';

const Navbar = () => {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    return (
        <header className="site-header">
            {/* Top Bar */}
            <div className="top-bar px-3 px-lg-0">
                <div className="container d-flex justify-content-end gap-3 align-items-center h-100">
                    <div className="social-links d-flex">
                        <div>
                            <a href="#"><i className="bi bi-instagram"></i></a>
                            <a href="#"><i className="bi bi-facebook"></i></a>
                            <a href="#"><i className="bi bi-whatsapp"></i></a>
                        </div>
                        <div className="top-title d-none d-md-block">
                            <span className="top-bar-text">LAMP EDIFICATION</span>
                        </div>
                    </div>
                    <div className="top-cta">
                        <button className="btn-donate">Faire un don</button>
                    </div>
                </div>
            </div>

            {/* Main Navbar */}
            <nav className="navbar-main p-1 px-3 px-lg-0 border-bottom bg-white shadow-sm">
                <div className="container d-flex justify-content-between align-items-center">
                    <Link to="/" className="navbar-logo-wrap d-flex justify-content-center align-items-center text-decoration-none" onClick={closeMenu}>
                        <img src={logo} alt="Logo" className="nav-logo" />
                        <h5 className="text-dark fw-bold ms-2 mb-0 d-none d-sm-block">LAMP Edification</h5>
                    </Link>

                    {/* Liens desktop */}
                    <ul className="navbar-nav-links d-none d-lg-flex gap-4 mb-0 align-items-center">
                        <li><Link to="/" className={location.pathname === "/" ? "active" : ""}>Accueil</Link></li>
                        <li><Link to="/qui-sommes-nous" className={location.pathname === "/qui-sommes-nous" ? "active" : ""}>Qui sommes-nous ?</Link></li>
                        <li><Link to="/nos-meditations" className={location.pathname === "/nos-meditations" ? "active" : ""}>Nos Méditations</Link></li>
                        <li><Link to="/contact" className={location.pathname === "/contact" ? "active" : ""}>Contact</Link></li>
                    </ul>

                    {/* Bouton hamburger mobile */}
                    <button
                        className="navbar-toggler d-lg-none border-0 bg-transparent text-dark fs-2"
                        onClick={() => setMenuOpen(open => !open)}
                        aria-label="Menu"
                    >
                        <i className={`bi ${menuOpen ? 'bi-x-lg' : 'bi-list'}`}></i>
                    </button>
                </div>

                {/* Menu mobile déroulant */}
                <div className={`navbar-mobile-menu ${menuOpen ? 'navbar-mobile-open' : ''}`}>
                    <ul className="list-unstyled mb-0 py-2">
                        <li>
                            <Link to="/" className={location.pathname === "/" ? "active" : ""} onClick={closeMenu}>
                                <i className="bi bi-house-door me-2"></i>Accueil
                            </Link>
                        </li>
                        <li>
                            <Link to="/qui-sommes-nous" className={location.pathname === "/qui-sommes-nous" ? "active" : ""} onClick={closeMenu}>
                                <i className="bi bi-people me-2"></i>Qui sommes-nous ?
                            </Link>
                        </li>
                        <li>
                            <Link to="/nos-meditations" className={location.pathname === "/nos-meditations" ? "active" : ""} onClick={closeMenu}>
                                <i className="bi bi-book me-2"></i>Nos Méditations
                            </Link>
                        </li>
                        <li>
                            <Link to="/contact" className={location.pathname === "/contact" ? "active" : ""} onClick={closeMenu}>
                                <i className="bi bi-envelope me-2"></i>Contact
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    );
};

export default Navbar;
